// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".master--scope__sticky[data-v-78a245ec] {\n  position: sticky;\n  top: -20px;\n  background-color: #ffffff;\n  z-index: 99;\n  padding-block: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
